// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_style_tabs__3IvMc","chips":"tabs_style_chips__vp9lY","selectors":"tabs_style_selectors__2HanL","fill":"tabs_style_fill__3AtXj","tab":"tabs_style_tab__7kREp"};